import type { FC } from 'react';

import { CustomTable } from 'components/table/style';
import { Table } from 'enable-ui';

import type { FunctionalTest } from 'modules/dashboard/core/type';

export const FunctionalTestTable: FC<{ columns: any[]; data: FunctionalTest[] }> = ({
  columns,
  data,
}) => {
  return (
    <div>
      {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Typography weight={700}>Functional test</Typography>
        <Tooltip content="" arrow="false">
          <InfoIcon />
        </Tooltip>
      </div> */}
      <CustomTable $isShowBorder={false}>
        <Table
          columns={columns}
          dataSource={data}
          total={0}
          tableKey={''}
          queryState={{ page: 1, limit: 9999 }}
          paginationConfigs={{
            show: false,
          }}
        />
      </CustomTable>
    </div>
  );
};
